<div class="component">
    <div class="component__header">Currency Selector</div>
    <config-controls
        #configControls
        [sections]="sections"
        [fullConfigPath]="fullConfigPath"></config-controls>
</div>